import axios, { AxiosRequestConfig } from 'axios'
import { requestInteceptor } from './requestInterceptors'
import { responseErr, responseInterceptor } from './responseInterceptors'

export const devInstance = axios.create({
    baseURL:
        process.env.NODE_ENV === 'development'
            ? `${process.env.REACT_APP_API_URL}/api/v1`
            : //@ts-ignore
              `${window.env.appUrl}/api/v1`,
    headers: {},
})

devInstance.interceptors.request.use(
      //@ts-ignore
    (config: AxiosRequestConfig) => requestInteceptor(config),
    (error: any) => {
        return Promise.reject(error)
    }
)
devInstance.interceptors.response.use(
    (res) => responseInterceptor(res),
    async (err) => responseErr(err, devInstance, `$`)
)
